import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Email|Properties|Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsEmailsPropertiesForm';
export type SPCatalogsEmailsPropertiesFormLocNames =
	| `${LocNameStart}LabelFromName`
	| `${LocNameStart}ContentFromNameHint`
	| `${LocNameStart}LabelFromEmail`
	| `${LocNameStart}ContentFromEmailHint`
	| `${LocNameStart}ErrorFromEmailInvalid`
	| `${LocNameStart}LabelDisabled`
	| `${LocNameStart}LabelBccEmail`
	| `${LocNameStart}ErrorBccEmailInvalid`
	| `${LocNameStart}ButtonDeleteBccEmail`
	| `${LocNameStart}ButtonAddBccEmail`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonSave`;

export const spCatalogsEmailsPropertiesFormLocs: LocDefs<SPCatalogsEmailsPropertiesFormLocNames> = {
	SPCatalogsEmailsPropertiesFormLabelFromName: {
		defaultValue: 'From Name',
		description: 'Label for: From Name.',
		displayPath: `${pathStart}From Name`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.FromName',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormContentFromNameHint: {
		defaultValue: 'When blank, "CertMetrics" will be used.',
		description: 'Hint for: From Name.',
		displayPath: `${pathStart}From Name Hint`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Details.FieldHint.FromName',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormLabelFromEmail: {
		defaultValue: 'From Email',
		description: 'Label for: From Email.',
		displayPath: `${pathStart}From Email`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.FromEmail',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormContentFromEmailHint: {
		defaultValue:
			'Due to anti-spam measures such as SPF and DMARC, please contact your Alpine TPM to begin the process of using a custom "from" email address in outgoing notifications. When customized, it will be necessary to coordinate with the manager of the domain name\'s DNS record to add "a:mail.certmetrics.com" to the SPF record. When blank, the default email address "do-not-reply&#64;certmetrics.com" will be used.',
		description: 'Hint for: From Email.',
		displayPath: `${pathStart}From Email Hint`,
		displayType: 'Content',
		legacyName: 'Core/Catalogs.Emails.Details.FieldHint.FromEmail',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormErrorFromEmailInvalid: {
		defaultValue: 'Invalid email address',
		description: 'Error message for: From Email.',
		displayPath: `${pathStart}From Email Invalid`,
		displayType: 'Error',
		legacyName: 'Core/Catalogs.Emails.Details.FieldError.FromEmailInvalid',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormLabelDisabled: {
		defaultValue: 'Disabled',
		description: 'Label for: Disabled.',
		displayPath: `${pathStart}Disabled`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.Disabled',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormLabelBccEmail: {
		defaultValue: 'BCC Email',
		description: 'Label for: BCC Email.',
		displayPath: `${pathStart}BCC Email`,
		displayType: 'Label',
		legacyName: 'Core/Catalogs.Emails.Details.FieldLabel.BCC',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormErrorBccEmailInvalid: {
		defaultValue: 'Invalid email address',
		description: 'Error message for: BCC Email.',
		displayPath: `${pathStart}BCC Email Invalid`,
		displayType: 'Error',
		legacyName: 'Core/Catalogs.Emails.Details.FieldError.BCCEmailInvalid',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormButtonDeleteBccEmail: {
		defaultValue: 'Delete BCC Email',
		description: 'Button to delete the BCC Email.',
		displayPath: `${pathStart}Delete BCC Email`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.DeleteBCC',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormButtonAddBccEmail: {
		defaultValue: 'Add BCC Email',
		description: 'Button to add the BCC Email.',
		displayPath: `${pathStart}Add BCC Email`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.AddBCC',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.PropertiesCancel',
		...sharedProperties,
	},
	SPCatalogsEmailsPropertiesFormButtonSave: {
		defaultValue: 'Save',
		description: 'Save button',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		legacyName: 'Core/Catalogs.Emails.Details.Button.PropertiesSave',
		...sharedProperties,
	},
};

export type SPCatalogsEmailsPropertiesFormLocType = LocMap<SPCatalogsEmailsPropertiesFormLocNames>;
